<div id="shop" class="page-layout carded fullwidth inner-scroll">

    <div class="top-bg accent"></div>

    <div class="center">

        <div class="header accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
             fxLayoutAlign.gt-sm="space-between center">

            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    business
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    Lojas
                </span>
            </div>

            <div class="search-wrapper mr-20 ml-20">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon matTooltip="Pesquisa avançada" (click)="openFilter()">filter_list_sharp</mat-icon>
                    <input placeholder="Pesquisar..." [(ngModel)]="searchText" (keydown.enter)="search()">
                    <mat-icon *ngIf="searchText.length > 0" (click)="clear()">clear</mat-icon>
                </div>
            </div>

            <div fxLayoutAlign="end center">
                <button mat-raised-button class="fuse-white mt-24 mt-md-0" (click)="search()">
                    <mat-icon>search</mat-icon>
                    <span>Pesquisar</span>
                </button>

                <button mat-raised-button class="fuse-white ml-16 mt-24 mt-md-0"
                        matTooltip="Novo" [routerLink]="'/view/shop/new'">
                    <mat-icon>add</mat-icon>
                    <span>Novo</span>
                </button>
            </div>
        </div>

        <div class="content-card mat-elevation-z8">

            <mat-table class="shop-table" [dataSource]="dataSource" [@animateStagger]="{value:'50'}" matSort
                       fusePerfectScrollbar>

                <mat-header-row *matHeaderRowDef="columns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let shop; columns: columns;" matRipple></mat-row>

                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Código</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p class="text-truncate">{{shop.id}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="image">
                    <mat-header-cell *matHeaderCellDef>Imagem</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <img [src]="getImageUrl(shop.id)"
                             onerror="this.src='assets/images/sem-imagem.png';this.onerror='';"
                             class="image"/>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Nome</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.title}}" class="text-truncate">{{shop.name}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="fundation">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Fundação</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.fundation | date :'dd/MM/yyyy'}}" class="text-truncate">{{shop.fundation | date :'dd/MM/yyyy'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Dias de reunião</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.description}}" class="text-truncate">{{shop.description}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="rito">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Rito</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.rito}}" class="text-truncate">{{shop.rito}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="power">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Potência</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.power}}" class="text-truncate">{{shop.power}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Usuário</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.user?.name}}" class="text-truncate">{{shop.user?.name}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                    <mat-cell *matCellDef="let shop">
                        <p matTooltip="{{shop.status}}" class="text-truncate">{{getTextStatus(shop.status)}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center">
                        <span>Opções</span>
                    </mat-header-cell>

                    <mat-cell *matCellDef="let shop">
                        <div fxFlex="row" fxLayoutAlign="center center">

                            <button mat-mini-fab class="blue-600 icon" matTooltip="Editar"
                                    [routerLink]="'/view/shop/'+shop.id+''">
                                <mat-icon [inline]="true" class="blank">edit</mat-icon>
                            </button>

                            <button mat-mini-fab class="red icon" matTooltip="Deletar"
                                    (click)="delete(shop.id)">
                                <mat-icon [inline]="true" class="blank">delete</mat-icon>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>

            </mat-table>

            <mat-paginator
                    fxLayoutAlign="center center"
                    [length]="lengthItems"
                    [pageSize]="10"
                    [showFirstLastButtons]="true"
                    [pageSizeOptions]="[10, 25, 50, 75, 100]">
            </mat-paginator>

        </div>
    </div>
</div>
